import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router
  ) {
    let userdata = this.userService.getToken();
    if (userdata.token) {
      this.userService.isLoggedIn = true;
    } else {
      this.userService.isLoggedIn = false;
    }

  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let userdata = this.userService.getToken();
    // console.log(userdata);
    if (userdata.token) {
      this.router.navigate(['dashboard']);
      this.userService.isLoggedIn = true;
      return false
    } else {
      this.userService.isLoggedIn = false;
      return true;
    }
  }
}
